import { C } from "../../shared/theme";
import { Tile } from "../../shared/Tile";
import { intro } from "./learnStyles";

// Line icons, 22px, drawn in the tile's hue.
const ICONS = {
  cycle: <><path d="M21 12a9 9 0 1 1-3-6.7" /><polyline points="21 3 21 9 15 9" /></>,
  hourglass: <><path d="M6 2h12" /><path d="M6 22h12" /><path d="M7 2v4a5 5 0 0 0 10 0V2" /><path d="M7 22v-4a5 5 0 0 1 10 0v4" /></>,
  bolt: <polyline points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />,
  buoy: <><circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="4" /><line x1="4.9" y1="4.9" x2="9.2" y2="9.2" /><line x1="14.8" y1="14.8" x2="19.1" y2="19.1" /><line x1="14.8" y1="9.2" x2="19.1" y2="4.9" /><line x1="4.9" y1="19.1" x2="9.2" y2="14.8" /></>,
  chat: <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />,
  book: <><path d="M2 4h6a4 4 0 0 1 4 4v13a3 3 0 0 0-3-3H2z" /><path d="M22 4h-6a4 4 0 0 0-4 4v13a3 3 0 0 1 3-3h7z" /></>,
};

// Craig asked for more than the old one-liner (20 Oct 2026: "It's underwhelming").
const INTRO = "Procrastination isn't laziness, and it isn't bad time management. We put a task off because of how it makes us feel: bored, anxious, overwhelmed or afraid of doing it badly. Putting it off makes that feeling go away for now, so we do it again next time. Once you know which feeling is in the way, you can choose something that works on it.";

// One tile per destination and nothing else (For Club and Country's home grammar).
// The four destinations wear a hue; the two utilities (Chat, sources) stay neutral
// with only a coloured icon, so they read as secondary.
export function LearnHome({ onOpen, onTalk }) {
  const tiles = [
    { title: "How motivation works", sub: "Start here", icon: "cycle", hueName: "purple", onClick: () => onOpen("foundations") },
    { title: "Why we put things off", sub: "21 reasons", icon: "hourglass", hueName: "amber", onClick: () => onOpen("why") },
    { title: "Conquer procrastination", sub: "27 things that help", icon: "bolt", hueName: "teal", onClick: () => onOpen("how") },
    { title: "I'm stuck right now", sub: "Pick how you feel", icon: "buoy", hueName: "blue", onClick: () => onOpen("stuck") },
    { title: "Talk it through", sub: "In Chat", icon: "chat", hueName: "grey", iconHue: "green", onClick: onTalk },
    { title: "The research", sub: "Where this comes from", icon: "book", hueName: "grey", onClick: () => onOpen("research") },
  ];
  return (
    <>
      <div style={{ padding: "8px 20px 6px", display: "flex", flexDirection: "column", gap: 8 }}>
        <h1 tabIndex={-1} style={{ outline: "none", margin: 0, fontSize: 24, fontWeight: 800, letterSpacing: "-0.01em", lineHeight: 1.2, color: C.text }}>The Psychology of Procrastination</h1>
        <p style={intro()}>{INTRO}</p>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 10, padding: "14px 16px 20px" }}>
        {tiles.map(t => <Tile key={t.title} {...t} icon={ICONS[t.icon]} />)}
      </div>
    </>
  );
}
